import DbSoftSelect from './db-soft-select.vue'
DbSoftSelect.install = function (Vue) {
  Vue.component(DbSoftSelect.name, DbSoftSelect);
};
export default DbSoftSelect



// WEBPACK FOOTER //
// ./src/omnis-business/db-soft-select/index.js